import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { breadTypeOptions } from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Select from 'react-select'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { isNotNumericDecimal } from 'context/Utilities'

const BreadPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    BreadType: item.BreadType,
    BreadSize: item.BreadSize,
  })

  const methods = useFormContext()
  const { setSelectReviewer, onChangeReviewer, asterisk } = useFormUtils()

  useEffect(() => {
    if (item !== null) {
      const { BreadType, BreadSize } = item
      setPackaging({
        BreadType,
        BreadSize,
      })
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <Row>
      <Col xs={6}>
        <h6>Type {asterisk}</h6>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={breadTypeOptions}
          defaultValue={{
            label: packaging.BreadType,
            value: packaging.BreadType,
          }}
          name="BreadType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Type'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="BreadType"
            message={'⚠ Type is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <FormGroup>
          <h6>Size {asterisk}</h6>
          {/* <Controller
            as={Input}
            name="BreadSize"
            placeholder={'Size'}
            defaultValue={packaging.BreadSize}
            control={methods.control}
            rules={{ required: true, maxLength: 15 }}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={true}
          />
          <p className={'text-danger'}>
            {methods.errors.BreadSize &&
              methods.errors.BreadSize.type === 'required' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ Bread size is required.
                </Alert>
              )}
            {methods.errors.BreadSize &&
              methods.errors.BreadSize.type === 'maxLength' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ Bread size exceeds 15 characters.
                </Alert>
              )}
          </p>{' '} */}
          <Controller
            as={Input}
            name="BreadSize"
            placeholder={'12 - 48 ounces'}
            defaultValue={packaging.BreadSize}
            control={methods.control}
            rules={{
              validate: containerSize =>
                containerSize >= 12 && containerSize <= 48,
              maxLength: {
                value: 5,
                message: '⚠ Size exceeds 5 characters.',
              },
            }}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="BreadSize"
              message={'⚠ Size must be between 16 - 18 ounces.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
    </Row>
  )
}

BreadPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default BreadPackageReview
